module.exports = __webpack_public_path__ + "static/media/meet-the-team-3.a1224571.png";